import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { Accordion } from 'core/controls';
import { TranslateContext } from 'core/translate';
import SimpleOptionGroup from '../common/options/SimpleOptionGroup';
import OptionsPage from '../common/OptionsPage';

const Interior = ({ options, radios, safety }) => {
  return (
    <OptionsPage>
      {({ onChange, onDetails }) => (
        <Accordion>
          <TranslateContext.Consumer>
            {translate => (
              <Fragment>
                <SimpleOptionGroup
                  header={translate('component.common.select.interior.radios')}
                  options={radios}
                  disableSingleOption={true}
                  analyticsKey="radios"
                  id="interior-radios"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <SimpleOptionGroup
                  header={translate('component.common.select.interior.options')}
                  options={options}
                  analyticsKey="interior options"
                  analyticsKey2={option => option.shortCFD}
                  id="interior-options"
                  onChange={onChange}
                  onDetails={onDetails}
                />
                <SimpleOptionGroup
                  header={translate('component.common.select.interior.safety')}
                  options={safety}
                  analyticsKey="safety options"
                  analyticsKey2={option => option.shortCFD}
                  id="interior-safety"
                  onChange={onChange}
                  onDetails={onDetails}
                />
              </Fragment>
            )}
          </TranslateContext.Consumer>
        </Accordion>
      )}
    </OptionsPage>
  );
};

const mapStateToProps = state => {
  const interiorOptions = state.config.interior;
  return {
    options: _.get(interiorOptions, 'interior.options', []),
    radios: _.get(interiorOptions, 'interior.radio', []),
    safety: _.get(interiorOptions, 'interior.safety', [])
  };
};

export default withRouter(connect(mapStateToProps)(Interior));
